import { render } from "./ErrorLayoutComponent.vue?vue&type=template&id=41f7eebc"
import script from "./ErrorLayoutComponent.vue?vue&type=script&lang=js"
export * from "./ErrorLayoutComponent.vue?vue&type=script&lang=js"

import exportComponent from "/builds/phi-indonesia/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__